import { create } from 'zustand';

type State = {
  gateway: string;
};

type Action = {
  setGateway: (gateway: string) => void;
  getGateway: () => string;
};

export const useGateway = create<State & Action>()((set, get) => ({
  gateway: '',
  getGateway: () => get().gateway,
  setGateway: (gateway: string) => set(() => ({ gateway })),
}));
